import * as $ from 'jquery';
import domtoimage from 'dom-to-image';

$(() => {
    const statsPage = $('[data-stats-page]');
    if (statsPage.length === 0) {
        return;
    }

    let container = $(statsPage[0]);

    $('.download').on("click", function(e) {
        let actionContainer = $(e.currentTarget).parent();
        let t = actionContainer.parent().parent();
        actionContainer.hide();
        domtoimage.toJpeg(t[0], { quality: 0.95})
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'stats.jpeg';
                link.href = dataUrl;
                link.click();

                actionContainer.show();
            });
    });
    
    $('.expandChart').on("click", function(e) {
        let t = $(e.currentTarget);
        let parent = t.parent().parent().parent();
        parent.toggleClass(function() {
            if ( $( this ).is( ".col-md-6" ) ) {
                return "col-md-12";
            }
            if ( $( this ).is( ".col-md-12" ) ) {
                return "col-md-6";
            }
        });

        let icon = t.find('.bi');
        icon.toggleClass(function() {
            if ( $( this ).is( ".bi-arrows-angle-expand" ) ) {
                $(this).removeClass("bi-arrows-angle-expand");
                return "bi-arrows-angle-contract";
            }
            if ( $( this ).is( ".bi-arrows-angle-contract" ) ) {
                $(this).removeClass("bi-arrows-angle-contract");
                return "bi-arrows-angle-expand";
            }
        });
    });
});
